module.exports = __webpack_public_path__ + "static/img/zhuanli-1.4fed6e14.png";